import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { intentPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { getLocale, useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function IntentSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
  filterOptions,
  backOriDefaultValue
}: SingleCommonType) {
  const { formatOptionsMessage } = useLanguage();
  const locale = getLocale();

  const intentOption = useMemo(() => {
    if (!filterOptions) return [];
    return Object.entries(filterOptions).map(([key, value]) => ({
      value: key,
      text: locale === 'en-US' ? value : key,
    }));
  }, [filterOptions, locale]);

  const {
    selects: intentOptionSelect,
    setSelects: setIntentOptionSelect,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'intent',
    options: intentOption?.map((item) => item.value) || [],
    firstExcludeOptions: ['error'],
    backOriDefaultValue
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  const { formatMessage } = useIntl();
  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'intent',
      commonBackInfo(
        { intents: intentOptionSelect },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [intentOptionSelect, formatMessage]);

  return (
    <div className={diffClassName}>
      <CustomSelect
        ref={customSelectRef}
        matchButtonWidth={false}
        placeholderText={intentPlaceholder[lang]}
        onClear={() => setIntentOptionSelect([])}
        selectOptionsInfo={[intentOptionSelect, setIntentOptionSelect]}
        options={intentOption}
        pointKey={FilterButtonPoint.intent}
      ></CustomSelect>
    </div>
  );
}
